// Values required by the API
export enum SUGGESTION_STATUS {
    SUBMITTED = 'SUBMITTED',
    IN_PROGRESS = 'IN_PROGRESS',
    ACCEPTED = 'ACCEPTED',
    PARTIALLY_ACCEPTED = 'PARTIALLY_ACCEPTED',
    REJECTED = 'REJECTED',
    SUPERSEDED = 'SUPERSEDED',
}

// Values required by the status icons
export const SUGGESTION_STATUS_VALUES: { [key in SUGGESTION_STATUS]: string } = {
    SUBMITTED: 'submitted',
    IN_PROGRESS: 'in progress',
    ACCEPTED: 'accepted',
    PARTIALLY_ACCEPTED: 'partially accepted',
    REJECTED: 'rejected',
    SUPERSEDED: 'superseded',
} as const

// Export a type for the form
export type SuggestionStatus = keyof typeof SUGGESTION_STATUS
